import { ChevronDown } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

const timeRanges = [
  { label: "7 days", value: 7 },
  { label: "30 days", value: 30 },
  { label: "90 days", value: 90 },
  { label: "All time", value: 365 },
];

interface TimeRangeSelectorProps {
  rangeDays: number;
  onRangeDaysChange: (days: number) => void;
  align?: "start" | "center" | "end";
}

export function TimeRangeSelector({
  rangeDays,
  onRangeDaysChange,
  align = "end",
}: TimeRangeSelectorProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm">
          {timeRanges.find((r) => r.value === rangeDays)?.label || `${rangeDays} days`}
          <ChevronDown className="w-4 h-4 ml-1" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align={align}>
        {timeRanges.map((range) => (
          <DropdownMenuItem
            key={range.value}
            onClick={() => onRangeDaysChange(range.value)}
            className={cn(range.value === rangeDays && "bg-muted")}
          >
            {range.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
